import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-status-icon',
    templateUrl: './status-icon.component.html',
    styleUrls: ['./status-icon.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class StatusIconComponent implements OnInit {
  static readonly componentName = 'StatusIconComponent';
  
  @Input() isEnabled: boolean = true;
  @Input() isUnset: boolean = false;
  @Input() matTooltip: string = null;

  constructor() { }

  ngOnInit(): void {
  }

}
